import { motion } from "framer-motion";
import { Instagram, Linkedin, Twitter, MessageCircle } from "lucide-react";
import { WHATSAPP_LINK, ADMIN_EMAIL, scrollToSection } from "../lib/site";

const nav = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Results", href: "#results" },
  { label: "Founder", href: "#founder" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

const socials = [
  { icon: Instagram, label: "Instagram", href: "https://instagram.com" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/amitahuuja/" },
  { icon: Twitter, label: "Twitter", href: "https://x.com" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-midnight border-t border-coal/10 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-20 pb-10">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          data-testid="footer-brand-type"
          className="font-display font-900 tracking-tighter leading-none text-[13vw] lg:text-[9rem] text-outline select-none whitespace-nowrap"
        >
          TheBombayHouse
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-coal/10 pt-12">
          <div>
            <img
              src="/logo.png"
              alt="The Bombay House"
              className="h-28 w-auto mb-8"
            />
            <p className="text-sm leading-relaxed text-coal/55 max-w-xs">
              A Mumbai-based ecommerce consultancy helping Indian brands launch
              and scale on Amazon, Shopify and quick commerce.
            </p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-terracotta hover:text-gold transition-colors duration-300"
            >
              <MessageCircle size={16} />
              {ADMIN_EMAIL}
            </a>
          </div>

          <div>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-coal/40">
              Navigate
            </span>
            <nav className="mt-5 flex flex-col gap-3" data-testid="footer-nav">
              {nav.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(l.href);
                  }}
                  className="text-sm text-coal/60 hover:text-terracotta transition-colors duration-300 w-fit"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-coal/40">
              Follow
            </span>
            <div className="mt-5 flex gap-3" data-testid="footer-socials">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="w-11 h-11 border border-coal/15 flex items-center justify-center text-coal/60 hover:text-night hover:bg-terracotta hover:border-terracotta transition-colors duration-300"
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-coal/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-coal/35">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} TheBombayHouse. All rights reserved.
          </span>
          <span data-testid="footer-address">Veena Tower, Mumbai 400080 · Made in Mumbai, for brands everywhere.</span>
        </div>
      </div>
    </footer>
  );
};
